var React = require('react');

function Cloud2 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M7.73238 45.9998H90.2179C90.2179 45.9998 98.8511 45.2953 98.9987 37.2988C99.1463 29.3023 90.7618 24.817 83.302 28.6401C83.302 28.6401 85.2291 21.6639 79.5293 16.6781C73.8296 11.6962 66.9564 16.2623 66.9564 16.2623C66.9564 16.2623 71.6499 7.70758 61.6762 1.80935C51.7026 -4.08888 45.4977 6.04437 45.8319 10.7799C45.8319 10.7799 36.1069 -7.41144 15.6546 3.46871C15.6546 3.46871 3.58285 9.69803 9.70224 24.5668C9.70224 24.5668 -1.25827 22.5109 -3.70991 33.9108C-6.16155 45.3107 7.73238 45.9998 7.73238 45.9998Z","fill":"#EDF1F3"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"103","height":"46","fill":"white","transform":"translate(-4)"})))]);
}

Cloud2.defaultProps = {"width":"99","height":"46","viewBox":"0 0 99 46","fill":"none"};

module.exports = Cloud2;

Cloud2.default = Cloud2;
